import { render, staticRenderFns } from "./ProductSpec.vue?vue&type=template&id=17b478c4&"
import script from "./ProductSpec.vue?vue&type=script&lang=js&"
export * from "./ProductSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports